/** @format */

export function trackDataLayer(eventName, payload = {}, user = null) {
  // ensure dataLayer array exists
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    user: user.uuid ? { uuid: user.uuid } : { uuid: '' },
    ...payload
  });
}
